import { InputAdornment, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as SearchIcon } from '../../../../assets/images/search.svg';
import { CustomSelect } from '../../../../components/CustomSelect';
import { FirstTextSelect } from '../../../../components/FirstTextSelcet';
import { getEventDeclensionForm } from '../../../../utils/getEventDeclension';
import { useDispatch, useSelector } from 'react-redux';
import EnhancedTable from '../../../../components/EnhancedTable';
import { BONUS_RECORD_HEAD_CELLS } from '../../constants/bonusRecordHeadCell';
import { getBonusRecords } from '../../../../store/bonuses/actions';
import { useDebounce } from 'use-lodash-debounce';
import { BonusRecordTableBody } from '../../components/BonusRecordTableBody';
import { ReactComponent as BoxIcon } from '../../../../assets/images/box-grey.svg';
import { BONUS_RECORD_STATUSES } from '../../constants/bonusRecordVariables';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { DISABLED_CONTROL_TOOLTIP, PERMISSIONS } from '../../../../constants/variables';
import { NotFoundItems } from '../../../../components/NotFoundItems';

const styleInput = {
  size: 'small',
  variant: 'outlined'
};
const propsSelect = (name, text, options, value) => ({
  name,
  options,
  value,
  startAdornmentText: <FirstTextSelect text={text} />,
  ...styleInput
});

export const BonusRecord = () => {
  const dispatch = useDispatch();
  const { bonusRecords, fetchingBonusRecords } = useSelector((state) => state.bonuses);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const [filter, setFilter] = useState({
    orderBy: 'created_at',
    orderType: 'desc',
    created_at: '',
    search: '',
    transaction_status: BONUS_RECORD_STATUSES[0],
    customer_iin: { id: 'all', name: 'Все' },
    page: 0,
    size: 10,
    customer_account_id: 'Все',
    date_start: '',
    date_end: '',
  });

  const debouncedValue = useDebounce(filter.search, 800);

  const handlerOnChange = (e, field) => setFilter({ ...filter, page: 0, [field]: e });

  const dateToStringForFilter = date => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

  const isAllowedToListDeductionBonusTransactions = visibleBySectionPermission(permissions, PERMISSIONS.DEDUCTION.ListDeductionBonusTransactions.value);
  const isAllowedToRetrieveDeductionBonusTransactions = visibleBySectionPermission(permissions, PERMISSIONS.DEDUCTION.RetrieveDeductionBonusTransactions.value);

  useEffect(() => {
    dispatch(
      getBonusRecords(
        {
          page: filter.page + 1,
          order_type: filter.orderType,
          order_by: filter.orderBy,
          size: filter.size,
          search: filter.search !== '' ? filter.search : undefined,
          transaction_status: filter.transaction_status.value !== BONUS_RECORD_STATUSES[0].value ? filter.transaction_status.label : undefined,
          created_at: filter.created_at.toString().length ? filter.created_at : undefined,
          date_start: filter.date_start.toString().length ? dateToStringForFilter(filter.date_start) : undefined,
          date_end: filter.date_end.toString().length ? dateToStringForFilter(filter.date_end) : undefined,
        }
      )
    );  // eslint-disable-next-line
  }, [
    debouncedValue,
    filter.orderType,
    filter.orderBy,
    filter.size,
    filter.page,
    filter.transaction_status,
    filter.created_at,
    filter.date_start,
    filter.date_end,
  ]);

  return (
    <Box id="bonus-record">
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1" data-testid="Title">
        Учет бонусов
      </Typography>

      <Box m="24px 0" data-testid="FindRecord">
        <CustomInput
          value={filter.search}
          onChange={(e) => setFilter({ ...filter, search: e.target.value, page: 0 })}
          {...styleInput}
          sx={{width: '100%'}}
          type="search"
          placeholder="Поиск"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          disabled={!isAllowedToListDeductionBonusTransactions}
          tooltip={!isAllowedToListDeductionBonusTransactions ? DISABLED_CONTROL_TOOLTIP : null}
        />
      </Box>

      <Box display="grid" gridTemplateColumns="1fr 1fr 2fr" gap="24px" data-testid="Grid">
        <CustomDatePicker
          name="date_start"
          value={filter.date_start || ' '}
          onChange={(e) => { handlerOnChange(e || '', 'date_start') }}
          fixedPlaceholderText="Дата с:"
          inputProps={{ "data-testid": "date-start" }}
          offLastDate={false}
          {...styleInput}
          sx={{ width: '272px' }}
          data-testid="DateStart"
          disabled={!isAllowedToListDeductionBonusTransactions}
          tooltip={!isAllowedToListDeductionBonusTransactions ? DISABLED_CONTROL_TOOLTIP : null}
        />
        <CustomDatePicker
          name="date_end"
          value={filter.date_end || ' '}
          onChange={(e) => { handlerOnChange(e || '', 'date_end') }}
          fixedPlaceholderText="Дата по:"
          inputProps={{ "data-testid": "date-end" }}
          offLastDate={false}
          {...styleInput}
          sx={{ width: '272px' }}
          data-testid="DateEnd"
          disabled={!isAllowedToListDeductionBonusTransactions}
          tooltip={!isAllowedToListDeductionBonusTransactions ? DISABLED_CONTROL_TOOLTIP : null}
        />
        <Box display="flex">
          <CustomSelect
            {...propsSelect('transaction_status', 'Статус транзакции:', BONUS_RECORD_STATUSES, filter.transaction_status)}
            onChange={(e) => handlerOnChange(e, 'transaction_status')}
            sx={{ width: '470px' }}
            data-testid="TransactionSelect"
            disabled={!isAllowedToListDeductionBonusTransactions}
            tooltip={!isAllowedToListDeductionBonusTransactions ? DISABLED_CONTROL_TOOLTIP : null}
          />
        </Box>
      </Box>

      {
        isAllowedToListDeductionBonusTransactions ? (
          fetchingBonusRecords || bonusRecords?.items?.length ? (
            <>
              <Box>
                <Typography color="text.secondary" m="24px 0px" data-testid="FoundEvents">
                  Найдено {getEventDeclensionForm(bonusRecords?.items?.length, 'event')}
                </Typography>
              </Box>

              <EnhancedTable
                rows={bonusRecords?.items || []}
                headCells={BONUS_RECORD_HEAD_CELLS}
                filter={filter}
                total={bonusRecords?.total || 0}
                fetching={fetchingBonusRecords}
                heightRow={77}
                setFilter={setFilter}
              >
                <BonusRecordTableBody
                  data={bonusRecords?.items}
                  permissions={{ retrieve: isAllowedToRetrieveDeductionBonusTransactions }}
                />
              </EnhancedTable>
            </>
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" height="70vh" data-testid="NotFound">
              <Box display="flex" flexDirection="column" alignItems="center">
                <BoxIcon width="76px" />

                <Typography mt="28px" variant="h1" sx={{ color: 'text.primary', fontSize: 26, fontWeight: 600 }} component="h2">
                  События не найдены
                </Typography>
              </Box>
            </Box>
          )
        ) : (
          <NotFoundItems message="Вам запрещён доступ к просмотру списка операций" />
        )
      }
    </Box>
  );
};
